import { useRef } from 'react';
import { useReducedMotion, useScroll, useTransform } from 'framer-motion';

// 요소가 뷰포트를 지나는 동안 -distance ~ +distance 범위로 세로 이동하는 모션 값을 돌려준다.
// prefers-reduced-motion 설정 시에는 움직이지 않는다.
function useParallax(distance = 40, offset = ['start end', 'end start']) {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? [0, 0] : [distance, -distance]);

  return { ref, y, progress: scrollYProgress };
}

export default useParallax;
